import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as contentblockActions from '../actions/news.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { NewsService } from '../../services';

@Injectable()
export class NewsEffects {
  private actions$ = inject(Actions);
  private PageService = inject(NewsService);


  LoadBugs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadNews),
      switchMap(({ profileId, skip, take }) =>
        this.PageService.getNews(profileId || 0, skip, take).pipe(
          map(news => contentblockActions.LoadNewsSuccess({ news })),
          catchError(error => of(contentblockActions.LoadNewsFail({ error })))
        )
      )
    );
  });

  LoadOverview$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadNewsOverview),
      switchMap(({ profileId, skip, take }) =>
        this.PageService.getNews(profileId || 0, skip, take).pipe(
          map(news => contentblockActions.LoadNewsOverviewSuccess({ news })),
          catchError(error => of(contentblockActions.LoadNewsOverviewFail({ error })))
        )
      )
    );
  });

  LoadNewsDetail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadNewsDetail),
      switchMap(({ id }) =>
        this.PageService.getNewsDetail(id).pipe(
          map(news => contentblockActions.LoadNewsDetailSuccess({ news })),
          catchError(error => of(contentblockActions.LoadNewsDetailFail({ error })))
        )
      )
    );
  });
}
